document.addEventListener('DOMContentLoaded', () => {
 
    let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.7,
    };

    let callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animated'); 
            }
        });
    };
      
    let observer = new IntersectionObserver(callback, options);
 
    let targets = document.querySelectorAll(".grid:has(.shape)");

    targets.forEach(target => {
        observer.observe(target); 
    })

});